import React, { useContext } from "react";
import elementsContext from "./elementsContext";

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

function injectSectionElements(WrappedComponent) {
  function WithElementComponent(props) {
    const value = useContext(elementsContext);
    return (
      <WrappedComponent
        {...props}
        Elements={value.elements}
        mode={value.mode}
      />
    );
  }
  WithElementComponent.displayName = `WithElements(${getDisplayName(
    WrappedComponent
  )})`;
  return WithElementComponent;
}

export default injectSectionElements;
